// palette used here:
// https://coolors.co/003049-d62828-f77f00-fcbf49-eae2b7

const colors = {
  primary: '#2B70DE',
  lightPrimary: 'rgba(43, 112, 222, 0.5)',
  lighterPrimary: '#d4e2f8',
  lightestPrimary: '#e3ecfa',
  secondary: '#BFDBF7',
  tertiary: '#DB222A',
  gold: '#DE992B',
  orange: '#F88800',
  darkOrange: '#df7a00',
  lightOrange: '#FFF7E8',
  royalPurple: '#6A0499',
  darkRoyalPurple: '#4B006E',
  lightRoyalPurple: '#ECD0FF',
  background: '#ffffff',
  favorite: '#DB222A',
  beige: '#eae2b7',
  white: '#ffffff',
  black: '#000000',
  lightGray: '#f0f0f0',
  mediumLightGray: '#aeb1b5',
  mediumGray: '#61656A',
  darkGray: '#343a40',
  transparent: 'rgba(0,0,0,0)',
  whiteTransparent: 'rgba(256,256,256,0)',
  semiTransparentWhite: 'rgba(256,256,256,0.5)',
  semiTransparentGray: 'rgba(0, 0, 0, 0.3)',
  semiTransparentDarkGray: 'rgba(0, 0, 0, 0.6)',
  forSale: '#000',
  forSalePreviouslyViewed: '#61656A', // same as mediumGray
  red: '#DB222A',
  redOrange: '#E74524',
  soldOrLeased: '#DB222A',
  soldOrLeasedPreviouslyViewed: '#d9646f', // same as mediumRed
  green: '#72c749',
  lightGreen: '#72c749',
  lightestGreen: '#f0f9eb',
  lightRed: '#f8d7da',
  mediumRed: '#d9646f',
  lightYellow: '#FFF3CD',
  mediumYellow: '#C1AF7D',
  darkYellow: '#664D03',
  text: '#343a40',
  secondaryText: '#61656A', // same as medium gray
  success: '#acd1af',
  error: '#f47174',
  info: '#93caed',
  link: '#397CE7',
  userLocationDot: '#3785F5',
};

export default colors;
